import React from 'react';
import { Formik } from 'formik';

/*
  Wraps the Formik component and adds the following new properties:
  (1) initialDisabled (optional): object with the same fields as initialValues, except
  that the field values are all booleans. This object is stored under
  initialState.initialDisabled.
 */
export default function FormikEnhanced({ children, initialDisabled, ...props }) {
  return (
    <Formik
      enableReinitialize
      {...props}
      initialStatus={{ initialDisabled: initialDisabled || {} }}
    >
      {typeof children === 'function' ? (props) => <>{children({ ...props })}</> : children}
    </Formik>
  );
}
